module.exports = __webpack_public_path__ + "img/Frame 130.e66057b7.png";